import { combineReducers } from 'redux'
import general from './general'
import auth from './auth'
import mainForm from './mainForm'
import locale from './locale'
import generalData from './generalData'
import answerSheet from './answerSheet'
import submitButton from './submitButton'
import fieldsValueHistory from './fieldsValueHistory'
import aiGeneratedAnswers from './aiGeneratedAnswers'
import aiFormResults from './aiFormResults'
import reCaptchaData from './reCaptchaData'

const appReducer = combineReducers({
  mainForm,
  auth,
  general,
  locale,
  generalData,
  answerSheet,
  submitButton,
  fieldsValueHistory,
  aiGeneratedAnswers,
  aiFormResults,
  reCaptchaData,
})

export default appReducer
